function PageNotFound404() {
    return(
        <div>Page not found!</div>
    );
}

export default PageNotFound404;